
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_67ksh_93",
  "checkbox-control": "awsui_checkbox-control_k2y2q_67ksh_107",
  "outline": "awsui_outline_k2y2q_67ksh_115"
};
  